import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { BridgesFileComparisonProjectMainComponent } from '@app/components/bridges/filecomparison/project/main/main.component';

export const bridgesAppRoutes : Routes = [
    {
        path: 'filecomparison/project/:pid',
        component: BridgesFileComparisonProjectMainComponent
    },
    {
        path: 'filecomparison/project/:pid/file/:fuuid',
        component: BridgesFileComparisonProjectMainComponent
    },
    {
        path: 'filecomparison/project/:pid/artwork/:aid/file/:fuuid',
        component: BridgesFileComparisonProjectMainComponent
    },
];

@NgModule({
  imports: [
      RouterModule.forRoot(bridgesAppRoutes)
  ],
  exports: [RouterModule]
})
export class AppBridgesRouterModule { }
